// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finish-card[data-v-4559a3d4]{border-radius:24px!important;overflow:hidden;max-width:548px;margin:0 auto;width:100%;padding:32px;box-shadow:none}", ""]);
// Exports
module.exports = exports;
